import React, { useEffect } from 'react';
import { Box, Card, CardContent, Grid, Typography } from '@mui/material';

import { Card1, Card2, Card3, Card4 } from '../../Svg';



const VendorExcessCard = ({orderStatistics}) => {
    const data = orderStatistics?.data


    const statuses = [
        {
            title: 'New',
            count: data?.NEW?.totalCount || 0,
            today: `+${data?.NEW?.todayCount || 0} today`,
            icon: <Card1 />,
        },
       
        {
            title: 'Approved',
            count: data?.APPROVED?.totalCount || 0,
            today: `+${data?.APPROVED?.todayCount || 0} today`,
            icon: <Card4 />,
        },
    ];

  

    return (
        <Box sx={{ paddingBottom: '16px' }}>
            <Grid container spacing={2}>
                {statuses.map((status, index) => (
                    <Grid item xs={12} sm={6} md={3} key={index}>
                        <Card sx={{
                            display: 'flex', alignItems: 'flex-start', boxShadow: "none",
                            justifyContent: 'space-between', border: '1px solid #E0E2E7',
                        }}>
                            <CardContent>
                                <Typography variant="subtitle1" color="#777980" fontSize="16px">
                                    {status.title}
                                </Typography>
                                <Typography variant="h5" color="#1D1F2C" sx={{ p: '6px 0' }} fontSize="28px">
                                    {status.count}
                                </Typography>
                                <Typography variant="body2" color="#858D9D" fontSize="14px">
                                    {status.today}
                                </Typography>
                            </CardContent>
                            <Box sx={{ p: 2 }}>{status.icon}</Box>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default VendorExcessCard;
